import { type Theme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';
import { SvgContainer } from './styled.ts';

export type Bbfc12Props = {
  height?: number;
  sx?: SystemStyleObject<Theme>;
  width?: number;
};

export const Bbfc12 = ({ height = 35, sx, width = 35 }: Bbfc12Props) => (
  <SvgContainer height={height} sx={sx} viewBox="0 0 92.604 92.604" width={width} xmlns="http://www.w3.org/2000/svg">
    <defs>
      <clipPath id="a">
        <path d="M286.727 273.902h55.984v55.985h-55.984zm0 0" />
      </clipPath>
    </defs>
    <g
      clipPath="url(#a)"
      style={{ opacity: 1, stopOpacity: 1 }}
      transform="matrix(1.65422 0 0 1.65422 -474.31 -453.095)"
    >
      <path
        d="M314.715 328.902c-14.914 0-27.008-12.093-27.008-27.011 0-14.914 12.094-27.008 27.008-27.008 14.918 0 27.012 12.094 27.012 27.008 0 14.918-12.094 27.011-27.012 27.011m0-55c-15.457 0-27.992 12.532-27.992 27.989 0 15.46 12.535 27.992 27.992 27.992 15.46 0 27.992-12.531 27.992-27.992 0-15.457-12.531-27.989-27.992-27.989"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
    </g>
    <path
      d="M314.715 326.445c-13.559 0-24.55-10.992-24.55-24.55 0-13.563 10.991-24.555 24.55-24.555 13.562 0 24.555 10.992 24.555 24.555 0 13.558-10.993 24.55-24.555 24.55m0-51.562c-14.914 0-27.008 12.094-27.008 27.012 0 14.914 12.094 27.007 27.008 27.007 14.918 0 27.012-12.093 27.012-27.007 0-14.918-12.094-27.012-27.012-27.012"
      style={{
        fill: '#fff',
        fillOpacity: 1,
        fillRule: 'nonzero',
        opacity: 1,
        stopOpacity: 1,
        stroke: 'none',
      }}
      transform="matrix(1.65422 0 0 1.65422 -474.31 -453.095)"
    />
    <path
      d="M314.715 277.34c-13.559 0-24.55 10.992-24.55 24.55 0 13.563 10.991 24.555 24.55 24.555 13.562 0 24.555-10.992 24.555-24.554 0-13.559-10.993-24.551-24.555-24.551"
      style={{
        fill: '#ee7817',
        fillOpacity: 1,
        fillRule: 'nonzero',
        opacity: 1,
        stopOpacity: 1,
        stroke: 'none',
      }}
      transform="matrix(1.65422 0 0 1.65422 -474.31 -453.095)"
    />
    <path
      d="M309.246 291.762v19.644h-3.578v-11.234c0-1.863 0-2.414-1.602-2.414h-3.203v-2.242h.38c1.835-.032 4.308-.059 5.097-3.754zM325.836 308.383v3.027h-13.363v-2.824c2.504-1.719 4.98-4.078 6.144-5.27 1.074-1.105 2.88-2.996 2.88-5.59 0-1.511-.755-2.937-2.59-2.937-2.884 0-2.794 3.14-2.766 4.54l-3.668-.321c0-2.766.902-4.54 1.66-5.442 1.078-1.253 2.941-2.125 5.066-2.125 3.723 0 6.317 2.414 6.317 6.141 0 3.172-1.95 5.445-4.106 7.395-.437.378-3.055 2.59-4.164 3.406zm0 0"
      style={{
        fill: '#fff',
        fillOpacity: 1,
        fillRule: 'nonzero',
        opacity: 1,
        stopOpacity: 1,
        stroke: 'none',
      }}
      transform="matrix(1.65422 0 0 1.65422 -474.31 -453.095)"
    />
  </SvgContainer>
);
